import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import Nav from "@/components/landing/Nav";
import TopBar from "@/components/landing/TopBar";
import Hero from "@/components/landing/Hero";
import Showcase from "@/components/landing/Showcase";
import Partners from "@/components/landing/Partners";
import Credentials from "@/components/landing/Credentials";
import Story from "@/components/landing/Story";
import Offer from "@/components/landing/Offer";
import Benefits from "@/components/landing/Benefits";
import Scarcity from "@/components/landing/Scarcity";
import Process from "@/components/landing/Process";
import Guarantee from "@/components/landing/Guarantee";
import Locations from "@/components/landing/Locations";
import Faq from "@/components/landing/Faq";
import ReservationForm from "@/components/landing/ReservationForm";
import Footer from "@/components/landing/Footer";
import WhatsAppFab from "@/components/landing/WhatsAppFab";
import Popup from "@/components/landing/Popup";

import { AdminAuthProvider } from "@/contexts/AdminAuthContext";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const sonnerStyle = {
  background: "#0A0A0A",
  border: "1px solid rgba(212,175,55,0.4)",
  color: "#F4F4F5",
  borderRadius: 0,
  fontFamily: "Outfit, sans-serif",
};

function LandingPage() {
  const [stats, setStats] = useState({ total: 45, reserved: 0, remaining: 45, by_type: {} });

  const fetchStats = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/vouchers/stats`);
      setStats(data);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("Unable to fetch voucher stats", e?.message);
    }
  }, []);

  useEffect(() => {
    fetchStats();
    const t = setInterval(fetchStats, 15000);
    return () => clearInterval(t);
  }, [fetchStats]);

  return (
    <div className="App dark relative">
      <div className="grain-overlay" aria-hidden="true" />
      <TopBar />
      <Nav />
      <main>
        <Hero remaining={stats.remaining} total={stats.total} reserved={stats.reserved} />
        <Showcase />
        <Partners />
        <Credentials />
        <Story />
        <Offer />
        <Benefits />
        <Scarcity remaining={stats.remaining} reserved={stats.reserved} total={stats.total} />
        <Locations />
        <Process />
        <Guarantee />
        <Faq />
        <ReservationForm onReserved={fetchStats} remaining={stats.remaining} />
      </main>
      <Footer />
      <WhatsAppFab />
      <Popup />
    </div>
  );
}

function App() {
  return (
    <AdminAuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: sonnerStyle }} />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </AdminAuthProvider>
  );
}

export default App;
